import { throwType } from '../types/utils';
import { articleFragment, category } from './categoryTree';
import { getHomePath, getSearchPagePath } from '../utils/routes';
export function getCurrentPage(state) {
    return state.page.currentPage;
}
export function isLoginRequired(state) {
    const currentPage = state.page.currentPage;
    if (currentPage) {
        return currentPage.status === 'LoginRequired';
    }
    return false;
}
export function articlePageFetchingStatus(state, articleId) {
    const currentPage = state.page.currentPage;
    const loadingPage = state.page.loadingPage;
    if (currentPage &&
        currentPage.pageType === 'article' &&
        currentPage.articleId === articleId) {
        return currentPage.status;
    }
    if (loadingPage &&
        loadingPage.pageType === 'article' &&
        loadingPage.articleId === articleId) {
        return 'is-fetching';
    }
    return 'not-started';
}
export function categoryPageFetchingStatus(state, categoryId) {
    const currentPage = state.page.currentPage;
    const loadingPage = state.page.loadingPage;
    if (currentPage &&
        currentPage.pageType === 'category' &&
        currentPage.categoryId === categoryId) {
        return currentPage.status;
    }
    if (loadingPage &&
        loadingPage.pageType === 'category' &&
        loadingPage.categoryId === categoryId) {
        return 'is-fetching';
    }
    return 'not-started';
}
export function searchPageFetchingStatus(state, _searchTerm) {
    const currentPage = state.page.currentPage;
    const loadingPage = state.page.loadingPage;
    if (currentPage &&
        currentPage.pageType === 'search' &&
        currentPage.searchTerm === _searchTerm) {
        return currentPage.status;
    }
    if (loadingPage &&
        loadingPage.pageType === 'search' &&
        loadingPage.searchTerm === _searchTerm) {
        return 'is-fetching';
    }
    return 'not-started';
}
export function homePageFetchingStatus(state) {
    const currentPage = state.page.currentPage;
    const loadingPage = state.page.loadingPage;
    if (currentPage && currentPage.pageType === 'home') {
        return currentPage.status;
    }
    if (loadingPage && loadingPage.pageType === 'home') {
        return 'is-fetching';
    }
    return 'not-started';
}
export function searchFetchingStatus(state, query, page) {
    // Do we have it already?
    if (state.search.searchedTerm === query &&
        state.search.currentPage === page) {
        return 'has-fetched';
    }
    if (state.search.searchedTerm === query &&
        state.search.currentPage &&
        state.search.currentPage - 1 === page &&
        state.search.isFetching) {
        return 'is-fetching';
    }
    return 'not-started';
}
export function searchTerm(state) {
    if (!state.page.currentPage)
        return '';
    if (state.page.currentPage.pageType !== 'search')
        return '';
    return state.page.currentPage.searchTerm;
}
function homePageCrumbs(_state, { languageId }) {
    return [
        {
            linkType: 'home',
            path: getHomePath({ languageId }),
        },
    ];
}
function searchPageCrumbs(state, { languageId }) {
    const p = {
        linkType: 'search',
        searchTerm: searchTerm(state),
        path: getSearchPagePath({ languageId }),
    };
    return [...homePageCrumbs(state, { languageId }), p];
}
function categoryPageCrumbs(state, { categoryId, languageId }) {
    if (!categoryId)
        return homePageCrumbs(state, { languageId });
    const c = category(state, categoryId);
    if (!c)
        return homePageCrumbs(state, { languageId });
    const p = {
        linkType: 'category',
        linkId: categoryId,
        title: c.title,
        slug: c.slug,
        path: c.path,
    };
    return [
        ...categoryPageCrumbs(state, { categoryId: c.parentCategory, languageId }),
        p,
    ];
}
function articlePageCrumbs(state, { articleId, languageId }) {
    const a = articleFragment(state, articleId);
    if (!a)
        return homePageCrumbs(state, { languageId });
    const p = {
        linkType: 'article',
        linkId: articleId,
        title: a.title,
        slug: a.slug,
        path: a.path,
    };
    return [
        ...categoryPageCrumbs(state, { categoryId: a.categoryId, languageId }),
        p,
    ];
}
export function breadcrumbs(state, { languageId }) {
    const page = getCurrentPage(state);
    if (!page)
        return []; // this can't really happen
    switch (page.pageType) {
        case 'article':
            return articlePageCrumbs(state, {
                articleId: page.articleId,
                languageId,
            });
        case 'category':
            return categoryPageCrumbs(state, {
                categoryId: page.categoryId,
                languageId,
            });
        case 'home':
            return homePageCrumbs(state, { languageId });
        case 'search':
            return searchPageCrumbs(state, { languageId });
        case 'extra':
            return [];
        case 'error':
        case 'error401':
        case 'error404':
            return [];
        default:
            throwType(page);
    }
}
//# sourceMappingURL=page.js.map